import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const RadioButtonField = ({
  input = {},
  meta = {},
  className = null,
  displayText = ""
}) => {
  return (
    <div className={classNames('radio-button', className)}>
      <input
        id={input.id}
        type="radio"
        name={input.name}
        value={input.value}
        onChange={input.onChange}
      />
      <label htmlFor={input.id}>
        <span>
          <span />
        </span>
      </label>
      <span htmlFor={input.id} className="radio-input-display-value">{displayText}</span>
    </div>
  );
};

RadioButtonField.propTypes = {
  input: PropTypes.object,
  className: PropTypes.string
};

export default RadioButtonField;
